// extracted by mini-css-extract-plugin
export default {"DatesWrapper":"board_DatesWrapper_NDiC5","DaysOfWeekWrapper":"board_DaysOfWeekWrapper_uGxA1"};